/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('variant:changed', function (event) {
  var variant = event.detail && event.detail.variant;

  if (!variant) {
    return;
  }

  event.target.querySelectorAll('[data-chd-design-size]').forEach(function (size) {
    var optionPosition = size.getAttribute('data-option-position');
    var sizeValue = variant['option' + optionPosition];
    var valueElement = size.querySelector('[data-chd-design-size-value]');

    if (!valueElement || !sizeValue || sizeValue === 'Default Title') {
      size.hidden = true;
      return;
    }

    valueElement.textContent = (size.getAttribute('data-prefix') || '') + sizeValue;
    size.hidden = false;
  });
});

// ShopHelten - Upsell
$(function () {
  console.log("LOADING UPSELLS FUNCTIONS");
  $('.upsell-checkbox').click(function() {
    $(this).parent().find('.upsell-checkbox-label').toggleClass('is-checked');
  });

  $('.qty-input').keyup( (evt) => {
    let value = parseInt( $(evt.target).parent().parent().find('.qty-input').val() );
    // Updating quantity
    $(evt.target).parent().parent().find('.quantity').val(value);
  });

  $('.qty-plus').click( (evt) => {
    let value = parseInt( $(evt.target).parent().parent().find('.qty-input').val() );
    // Updating quantity
    $(evt.target).parent().parent().find('.quantity').val(value + 1);
    // Updating visually
    $(evt.target).parent().parent().find('.qty-input').val(value + 1);

    $(evt.target).parent().parent().find('.upsell-add-to-cart').attr( 'href', `/cart/add?id=${$('.upsell-add-to-cart').data('productid')}&quantity=${value + 1}` );
  });

  $('.qty-minus').click( (evt) => {
    let value = parseInt( $(evt.target).parent().parent().find('.qty-input').val() );

    if ($(evt.target).parent().parent().find('.quantity').val() > 1) {
      // Updating quantity
      $(evt.target).parent().parent().find('.quantity').val(value - 1);
      // Updating visually
      $(evt.target).parent().parent().find('.qty-input').val(value - 1);

      $(evt.target).parent().parent().find('.upsell-add-to-cart').attr( 'href', `/cart/add?id=${$('.upsell-add-to-cart').data('productid')}&quantity=${value - 1}` );
    }
  });

  // Handle se more function
  if ($('.product-upsell-wrapper.upsells_products').length > 8) {
      let count = 0;
      $('.product-upsell-wrapper.upsells_products').each( (index, obj) => {
          if ($(obj).is(":visible")) {
              count += 1;

              if (count > 8) {
                  $(obj).hide();
              }
          }
      });
      
      if (count > 8) {
          $('.upsells__load-more').show();
      }

      // Handles load more
      $('.upsells__load-more').click((evt) => {
          let currentVaraint = $('.product-form__selected-value').text();
          
          // Loop over each upsell for current variant
          $( '.product-upsell-wrapper.upsells_products[data-variant="' + currentVaraint + '"], .product-upsell-wrapper.upsells_products.upsells_main_product' ).each( (index, obj) => {
              if (!$(obj).is(":visible")) {
                  $(obj).show();
                  $('.upsells__load-more').hide();
                  $('.upsells__load-less').show();
              }
          })
      });

      // Handles load less
      $('.upsells__load-less').click((evt) => {
        let currentVaraint = $('.product-form__selected-value').text();
          
          // Loop over each upsell for current variant
          $( '.product-upsell-wrapper.upsells_products[data-variant="' + currentVaraint + '"], .product-upsell-wrapper.upsells_products.upsells_main_product' ).each( (index, obj) => {
              if (index >= 8 && $(obj).is(":visible")) {
                  $(obj).hide();
                  $('.upsells__load-more').show();
                  $('.upsells__load-less').hide();
              }
          })
      });
  } else {
      $('.upsells__load-more').hide();
  }

$('.upsell-add-to-cart').click(function(evt){
  evt.preventDefault();
  const productID = $(evt.target).data('productid');
  const quantity = $(evt.target).parent().parent().find('.qty-input').val();
  addItemToCart( productID, quantity, "1", "Months", parseInt($('.header__cart-count').text()));
});

function addItemToCart(variant_id, qty, frequency, unit_type, cartCount) {
  const updateCartCount = parseInt(cartCount) + parseInt(qty);
  data = {
    "id": variant_id,
    "quantity": qty
  }
  
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: async function() { 
      await document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      $('.header__action-item-link.header__cart-toggle').attr('aria-expanded', 'true');
      $('#mini-cart').attr('aria-hidden', 'false');

      // Register click outside mini-cart to close
      $(document).mouseup(function(e) {
        var container = $("#mini-cart");
        var trigger = $('.header__action-item-link.header__cart-toggle');

        if (!container.is(e.target) && container.has(e.target).length === 0 && !trigger.is(e.target) && trigger.has(e.target).length === 0) {
          $('.header__action-item-link.header__cart-toggle').attr('aria-expanded', 'false');
          $('#mini-cart').attr('aria-hidden', 'true');
        }
      });
    }
  });

}

  $('.block-swatch__item').click( (evt) => {
    evt.stopPropagation();

    var title = $(evt.currentTarget).attr('title');

    // Hide all elements
    document.querySelectorAll('.upsells_product_variant').forEach( element => {
      $(element).hide();
    });

    
    document.querySelectorAll('.upsells_product_variant').forEach( element => {
      var variant = element.dataset.variant;
      if (variant.length > 0) {  
        if ( variant.includes(title.replace(" mm", "")) ) {
          $(element).show();
        }
      }
    } );


    if ($('.product-upsell-wrapper').is(":visible")) {
      $(".chd-upsells-block").show();
    } else {
      $(".chd-upsells-block").hide();
    }

    if ($('.product-upsell-wrapper.upsells_products').length > 8) {
      let count = 0;
      $('.product-upsell-wrapper.upsells_products').each( (index, obj) => {
          if ($(obj).is(":visible")) {
              count += 1;

              if (count > 8) {
                  $(obj).hide();
              }
          }
      });
      
      if (count > 8) {
          $('.upsells__load-more').show();
      } else {
          $('.upsells__load-more').hide();
      }

      // Handles load more
      $('.upsells__load-more').click((evt) => {
          let currentVaraint = $('.product-form__selected-value').text();
          
          // Loop over each upsell for current variant
          $( '.product-upsell-wrapper.upsells_products[data-variant="' + currentVaraint + '"], .product-upsell-wrapper.upsells_products.upsells_main_product' ).each( (index, obj) => {
              if (!$(obj).is(":visible")) {
                  $(obj).show();
                  $('.upsells__load-more').hide();
                  $('.upsells__load-less').show();
              }
          })
      });

      // Handles load less
      $('.upsells__load-less').click((evt) => {
        let currentVaraint = $('.product-form__selected-value').text();
          
          // Loop over each upsell for current variant
          $( '.product-upsell-wrapper.upsells_products[data-variant="' + currentVaraint + '"], .product-upsell-wrapper.upsells_products.upsells_main_product' ).each( (index, obj) => {
              if (index >= 8 && $(obj).is(":visible")) {
                  $(obj).hide();
                  $('.upsells__load-more').show();
                  $('.upsells__load-less').hide();
              }
          })
      });
  } else {
      $('.upsells__load-more').hide();
  }

   
  });

// Product addition to quantity
$('.add_qty').click((event) => {
  event.preventDefault();
  const current_val = parseInt( $('.product_qty').val() );
  $('.product_qty').val( current_val + 1 );
});

$('.sub_qty').click((event) => {
  event.preventDefault();
  const current_val = parseInt( $('.product_qty').val() );

  if (current_val > 1) {
    $('.product_qty').val( current_val - 1 );
  }
});

if ($('.product-upsell-wrapper').is(":visible")) {
  $(".chd-upsells-block").show();
} else {
  $(".chd-upsells-block").hide();
}

  $("body").on(
      "click",
      '[name="checkout"], [name="goto_pp"], [name="goto_gc"]',
      function () {
          if (this.closest('[data-chd-cart-form]')) return;
          const checkbox = this.closest('form')?.querySelector('.terms-checkbox input');
          if (checkbox && !checkbox.checked) {
              let agreeTxt = window.languages.termsAndConditionsAgreeToTermsAlert;

              alert(
                agreeTxt
              );
              return false;
          }
      }
  );

let activeUpsells = 0;
$('.product-upsell-wrapper.upsells_products').each( (index, obj) => {
  if ($(obj).is(":visible")) {
      ++activeUpsells;
  }
});

if (activeUpsells <= 7) {
  $('.upsells__load-more').hide();
}

$('.block-swatch__item').click( (evt) => {
  let activeUpsells = 0;
    $('.product-upsell-wrapper.upsells_products').each( (index, obj) => {
      if ($(obj).is(":visible")) {
          ++activeUpsells;
      }
    });

    if (activeUpsells <= 7) {
      $('.upsells__load-more').hide();
    }
});

  // Initializes slick sliders
  // Use data-attribute to apply settings ex. data-slick='{"slidesToShow": 4, "slidesToScroll": 4}'
  // Documentation: https://github.com/kenwheeler/slick
  $(".initialize-slider").slick();


  // Custom trigger to open mini-cart
  // $('.header__cart-toggle')[0].click();
  // document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
  //   bubbles: true
  // }));


}); // DOM LISTENER
